export function processMultiSelectValues(
  value: string[] | string
): Array<{ value: string; label: string }> {
  let valueArray: string[] = [];

  if (typeof value[0] === 'string') {
    // Split the pipe-separated string into an array
    valueArray = value[0].split('|').filter(v => v.trim() !== '');
  } else if (Array.isArray(value)) {
    // If it's already an array, use it directly
    valueArray = value;
  }

  // Convert to the format expected by react-select
  const selectedValues = valueArray.map(v => ({
    value: v,
    label: v,
  }));

  return selectedValues;
}
